import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-card-pagine',
  templateUrl: './sample-card-pagine.component.html',
  styleUrls: ['./sample-card-pagine.component.scss']
})
export class SampleCardPagineComponent implements OnInit {

  @Input() block: any;
  @Input() margin: string = '';
  public isLinkEsternal: boolean = false;
  public domainWebsite = environment.urlApi;
  public isExport: boolean = false;
  public imgPath = '';
  public dataTitle = {
    title: '',
    hreflang: '',
    link: ''
  };
  public taxonomies: string = '';

  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.oninitComponent();
    this.setTaxonomies();
  }

  private oninitComponent(): void {
    this.dataTitle = this.nodeService.retriveLinkTagA(this.block.field_titolo, 'a');
    this.imgPath = this.domainWebsite + this.nodeService.retrieveImage(this.block.field_immagine, 'src');
    this.isLinkEsternal = this.dataTitle ? this.nodeService.verifyLinkExternal(this.dataTitle.link) : false;
  }

  private setTaxonomies(): void {
    if (this.block && this.block.field_tassonomia_area_universita && this.block.field_tassonomia_area_universita.length) {
      let result = this.block.field_tassonomia_area_universita.reduce((acc: any, curr: any, index: number) => {
        if (index < 3) {
          acc.push(curr.name);
        }
        return acc;
      }, []).join(", ");
      const remainingCount = this.block.field_tassonomia_area_universita.slice(3).length;
      if (remainingCount > 0) {
        result += ` +${remainingCount}`;
      }    
      this.taxonomies = result;
    }
    
  }

}
